<template>
    <main class="faq-page-questions">
        <div class="faq-page-questions-menu">
            <a href="/faq" class="faq-page-questions-menu-link">
                <i class="ri-arrow-left-s-line"></i>
                Back to FAQ topics
            </a>
            <a
                href="#"
                @click.prevent="scrollToQuestion(question.id)"
                :id="`question-link-${question.id}`"
                class="faq-page-questions-menu-link"
                v-for="question in questions" :key="question.id">
                {{ question.question }}
            </a>
        </div>
        <div class="faq-page-questions-content">
            <div class="faq-page-questions-content-item" :id="`question-${question.id}`" v-for="question in questions" :key="question.id">
                <h3>{{ question.question }}</h3>
                <p>{{ question.answer }}</p>
                <a href="#" @click.prevent="scrollToTop" class="less-desktop-only">Back to top</a>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    props: {
        questions: {
            type: Array,
            required: true,
        },
    },
    methods: {
        scrollToQuestion(id) {
            const targetQuestion = document.getElementById(`question-${id}`);
            const targetLink = document.getElementById(`question-link-${id}`);
            // enable active class on this question, remove it from all other questions
            const allQuestions = document.querySelectorAll('.faq-page-questions-content-item');
            const allQuestionLinks = document.querySelectorAll('.faq-page-questions-menu-link');
            allQuestions.forEach((question) => {
                question.classList.remove('active');
            });
            allQuestionLinks.forEach((question) => {
                question.classList.remove('active');
            });
            targetQuestion.classList.add('active');
            targetLink.classList.add('active');
            targetQuestion.scrollIntoView({ behavior: 'smooth', block: 'center' });
        },
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
    },
};
</script>
